import React from 'react'
import { Button, Modal } from '@/components'
import type { useUserManagementViewModel } from '../useUserManagementViewModel'

type VM = ReturnType<typeof useUserManagementViewModel>

interface PasswordModalProps {
  showPasswordModal: VM['showPasswordModal']
  onClose: () => void
  passwordUser: VM['passwordUser']
  newPassword: VM['newPassword']
  setNewPassword: VM['setNewPassword']
  confirmPassword: VM['confirmPassword']
  setConfirmPassword: VM['setConfirmPassword']
  handleUpdatePassword: VM['handleUpdatePassword']
  /** Modal ici hata slotu: "Sifreler eslesmiyor" gibi validasyonlar dahil. */
  error: string | null
  onDismissError: () => void
  isSubmitting: boolean
}

const PasswordModal: React.FC<PasswordModalProps> = ({
  showPasswordModal,
  onClose,
  passwordUser,
  newPassword,
  setNewPassword,
  confirmPassword,
  setConfirmPassword,
  handleUpdatePassword,
  error,
  onDismissError,
  isSubmitting,
}) => {
  return (
    <Modal
      isOpen={showPasswordModal && !!passwordUser}
      onClose={onClose}
      title="Şifre Değiştir"
      error={error}
      onDismissError={onDismissError}
      isSubmitting={isSubmitting}
      size="sm"
      footer={
        <div className="flex justify-end space-x-3">
          <Button
            variant="outline"
            onClick={onClose}
            disabled={isSubmitting}
          >
            İptal
          </Button>
          <Button
            onClick={handleUpdatePassword}
            loading={isSubmitting}
            className="bg-orange-600 hover:bg-orange-700 text-white"
          >
            Şifreyi Değiştir
          </Button>
        </div>
      }
    >
      <div className="mb-4">
        <p className="text-sm text-gray-600">
          <strong>{passwordUser?.first_name} {passwordUser?.last_name}</strong> için yeni şifre belirleyin
        </p>
      </div>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Yeni Şifre *
          </label>
          <input
            type="text"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            disabled={isSubmitting}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100"
            placeholder="Yeni şifre (en az 6 karakter)"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Şifre Tekrar *
          </label>
          <input
            type="text"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            disabled={isSubmitting}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100"
            placeholder="Şifreyi tekrar girin"
          />
        </div>
      </div>
    </Modal>
  )
}

export default PasswordModal
